import { render, staticRenderFns } from "./default_container.vue?vue&type=template&id=225c29dc&scoped=true&"
import script from "./default_container.vue?vue&type=script&lang=js&"
export * from "./default_container.vue?vue&type=script&lang=js&"
import style0 from "./default_container.vue?vue&type=style&index=0&id=225c29dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c29dc",
  null
  
)

export default component.exports